export default function locationReplace(href) {
  window.location.replace(href);
}
